var productMetaJson = JSON.parse(
  document.getElementById("product-meta-json").textContent
);
$(document).on("click", "#dropdown_info", function () {
  window.location.hash = "#popup";
  $(".Weitere-model-main").addClass("model-open");
  $("body").addClass("popup_active");
});
$(document).on("click", ".Weitere_close_btn, .Weitere_bg_overlay", function () {
  if (window.location.hash) {
    history.replaceState(
      null,
      document.title,
      window.location.pathname + window.location.search
    );
  }
  $(".Weitere-model-main").removeClass("model-open");
  $("body").removeClass("popup_active");
});

$(document).on("click", "#halskette_short_textnain", function () {
  window.location.hash = "#popup";
  $(".Handzeichnung-model-main").addClass("model-open");
  $("body").addClass("popup_active");
});
$(document).on(
  "click",
  ".Handzeichnung_close_btn, .Handzeichnung_bg_overlay",
  function () {
    if (window.location.hash) {
      history.replaceState(
        null,
        document.title,
        window.location.pathname + window.location.search
      );
    }
    $(".Handzeichnung-model-main").removeClass("model-open");
    $("body").removeClass("popup_active");
  }
);

// back side btn open popup
$(document).on("click", "#ruckseiteng_popupbox", function () {
  var id = $("[data-product-select]").val();
  var selectedlength = $(".select-trigger .selected-option .list_item").length;
  $(".Ruckseitengravur-model-main .wrap_image_container img").hide();
  $(
    '.Ruckseitengravur-model-main .wrap_image_container img[data-id="' +
      id +
      '"]'
  ).show();
  setTimeout(function () {
    window.location.hash = "#popup";
    $(".Ruckseitengravur-model-main").addClass("model-open");
    $("body").addClass("popup_active");
  }, 500);
});

// back side cancel/skip btn open popup

$(document).on(
  "click",
  ".halskette_backname_texts .fflagship-collapsable-header-button2",
  function () {
    var id = $("[data-product-select]").val();
    var selectedlength = $(
      ".select-trigger .selected-option .list_item"
    ).length;
    $(".Ruckseitengravur-model-main .wrap_image_container img").hide();
    $(
      '.Ruckseitengravur-model-main .wrap_image_container img[data-id="' +
        id +
        '"]'
    ).show();
    setTimeout(function () {
      window.location.hash = "#popup";
      $(".Ruckseitengravur-model-main").addClass("model-open");
      $("body").addClass("popup_active");
    }, 500);
  }
);

$(document).on(
  "click",
  ".Ruckseitengravur_close_btn, .Ruckseitengravur_bg_overlay",
  function () {
    if (window.location.hash) {
      history.replaceState(
        null,
        document.title,
        window.location.pathname + window.location.search
      );
    }
    $(".Ruckseitengravur-model-main").removeClass("model-open");
    $("body").removeClass("popup_active");
  }
);
$(document).on("click", "#upload_info", function () {
  window.location.hash = "#popup";
  $(".aufFoto-model-main").addClass("model-open");
  $("body").addClass("popup_active");
});
$(document).on("click", ".aufFoto_close_btn, .aufFoto_bg_overlay", function () {
  if (window.location.hash) {
    history.replaceState(
      null,
      document.title,
      window.location.pathname + window.location.search
    );
  }
  $(".aufFoto-model-main").removeClass("model-open");
  $("body").removeClass("popup_active");
});

$(document).on("click", ".select-trigger", function () {
  $(".options").slideToggle("fast");
  $(this).toggleClass("selector_open");
  $(this)
    .parents(".custom-select")
    .find("#halskette_select")
    .toggleClass("selected_open");
});

$(document).on("click", "#halskette_select.options li", function () {
  var selectedOption = $(this).html();
  var selectedValue = $(this).attr("value");

  var selectedDataVal = $(this)
    .parents(".halskette_selecteditems")
    .find(".select-trigger .selected-option .list_item .list_item_value")
    .attr("data-value");

  $(".selected-option").html(selectedOption);
  $(".halskette_personen").val(
    $(this).find(".list_item_value").attr("data-valuePrice")
  );
  $("#halskette_select.options").slideUp("fast");
  $("#halskette_select.options").removeClass("selected_open");
  $(this)
    .parents(".custom-select")
    .find(".select-trigger")
    .removeClass("selector_open");
  // Perform any additional actions with the selected value here
  $(".add-to-cart").removeClass("disabled");
  $(".error").hide();
  $(".select-trigger").removeClass("error-text");
  getPrice();
});

$(document).on(
  "click",
  ".Ruckseitengravur-model-main .popup_fonts .frontname",
  function () {
    $(".Ruckseitengravur-model-main .popup_fonts .frontname").removeClass(
      "name_active"
    );
    $(this).addClass("name_active");
    var fontName = $(this).attr("data-named");
    //$('.popup_name_inputs'+fontName+'').show();

    var fontimageName = $(this).attr("data-imagename");
    $("#popup_name_images").attr("data-font", fontName);
    $("#popup_name_images").attr("class", fontimageName);

    var inputValue = $(".Ruckseitengravur-model-main .frontnameinput_1").val();
    var convertedValue = inputValue;
    var elements = $(".frontname_4.name_active");
    if (elements.length > 0) {
      var words = inputValue.split(" ");
      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        var wordFirstCharacter = word.charAt(0);

        var wordRestOfText = word.substr(1).toLowerCase();
        words[i] = wordFirstCharacter + wordRestOfText;
      }
      var convertedValue = words.join(" ");
      $(".Ruckseitengravur-model-main .frontnameinput_1").val(convertedValue);
    }
    $(".Ruckseitengravur-model-main #popup_name_images").html(convertedValue);

    updateFontSize(
      $(this).parents(".Ruckseitengravur-model-main").find(".frontnameinput_1")
    );
  }
);

// name backside popup save btn
$(document).on(
  "click",
  ".Ruckseitengravur-model-main .image_save_btn",
  function () {
    $(".halskette_backname_texts .halskette_rucks_texts").html("");
    $(".halskette_backname_texts .halskette_rucks_cancel_databtn").html("");

    var fontName = $(this)
      .parents(".Ruckseitengravur-model-main ")
      .find(".frontname.name_active")
      .attr("data-fontname");
    var nameInputVal = $(this)
      .parents(".Ruckseitengravur-model-main ")
      .find(".popup_name_inputs")
      .val();
    var index = $(this)
      .parents(".Ruckseitengravur-model-main ")
      .find(".frontname.name_active")
      .attr("data-numberdata");
    var indexPlus = index * 1;

    if (nameInputVal != "") {
      console.log(indexPlus);
      console.log(nameInputVal);
      $('[name="properties[Rückseite überspringen]"]').val("");
      $(".halskette_backname_texts .halskette_rucks_texts").show();
      $(".halskette_backname_texts .halskette_input_first").show();
      $(".halskette_backname_texts .halskette_header").hide();
      $(".halskette_backname_texts .halskette_rucks_texts").append(
        '<div class="halskette_after_savecontainer"><div class="halskette_wrapper_info"><div class="halskette_header halskette_headernew" style="display:block;"><div class="halskette_heading">Rückseitengravur</div></div><div class="engraving-messagesection row" data-autom="engraving-message-' +
          indexPlus +
          '"><div class="engraving-messagesection-item"><span style="display:none;">Name: </span><input class="popup_name_inputproperties inputsproperty_' +
          indexPlus +
          '" type="hidden" value="' +
          nameInputVal +
          '" name="properties[Rückseitengravur]"><input class="popup_font_inputproperties fontproperty_' +
          indexPlus +
          '" type="hidden" value="' +
          fontName +
          '" name="properties[_Rückseitengravur-Schriftart]"><span class="engraving-mixed engraving-messagevalue">' +
          nameInputVal +
          '</span></div></div></div><div class="engraving-addbutton"><button class="as-buttonlink engraving-buttonlink engraving-editbutton" type="button" data-trigger-id=".frontname_' +
          indexPlus +
          '"><span>bearbeiten</span></button><span class="engraving-lineseparator"></span><button class="as-buttonlink engraving-buttonlink engraving-remove" type="button" data-input-id=".frontnameinput_' +
          indexPlus +
          '" data-img-id=".frontnameimg_' +
          indexPlus +
          '" data-trigger-id=".frontname_' +
          indexPlus +
          '"><span>löschen</span></button></div></div>'
      );

      $(".halskette_backname_texts .halskette_name_btn").hide();
    } else {
      $('[name="properties[Rückseite überspringen]"]').val("Ja");
      $(".halskette_backname_texts .halskette_rucks_texts").html("");
      $(".halskette_backname_texts .halskette_header").hide();
      $(".halskette_backname_texts .halskette_name_btn").hide();
      $(".halskette_backname_texts .halskette_rucks_cancel_databtn").html(
        '<div class="halskette_name_cancel_data"><span class="flagship-collapsable-header">Rückseite überspringen</span><button class="flagship-collapsable-header-button" type="button" data-trigger-id="engraving-change">bearbeiten</button></div>'
      );
    }
    if (window.location.hash) {
      history.replaceState(
        null,
        document.title,
        window.location.pathname + window.location.search
      );
    }
    $(".Ruckseitengravur-model-main").removeClass("model-open");
    $("body").removeClass("popup_active");
    $(".halskette_backname_texts .backnamecancel_btn").hide();
    console.log("price change");
    getPrice();
  }
);

// name back side cancel btn
$(document).on(
  "click",
  ".Ruckseitengravur-model-main .image_cancel_btn",
  function () {
    var backsideval = $(this)
      .parents(".Ruckseitengravur-model-main")
      .find(".popup_name_inputs")
      .val();
    if (
      $(".halskette_backname_texts .halskette_rucks_texts").children().length >
      0
    ) {
      $(".halskette_backname_texts .halskette_name_btn").hide();
      console.log("if");
    } else {
      console.log("else");
      $(this)
        .parents(".Ruckseitengravur-model-main")
        .find(".popup_name_inputs")
        .val("");

      if (
        $(
          ".halskette_backname_texts .halskette_rucks_cancel_databtn"
        ).children().length > 0
      ) {
        console.log("if1");
        $(".halskette_backname_texts .halskette_rucks_texts").hide();
        $(".halskette_backname_texts .halskette_name_btn").hide();
      } else {
        console.log("else1");
        $(".halskette_backname_texts .halskette_rucks_texts").hide();
        $(".halskette_backname_texts .halskette_name_btn").show();
      }
    }
    if (window.location.hash) {
      history.replaceState(
        null,
        document.title,
        window.location.pathname + window.location.search
      );
    }
    $(".Ruckseitengravur-model-main").removeClass("model-open");
    $("body").removeClass("popup_active");
    // });
  }
);

// back side cancel/skip btn
$(document).on("click", ".backnamecancel_btn .halskette_name_btn", function () {
  $(".halskette_backname_texts .halskette_header").hide();
  $(".halskette_backname_texts .halskette_input_first").hide();
  $(this).hide();
  $(".halskette_backname_texts .halskette_rucks_cancel_databtn").html(
    '<div class="halskette_name_cancel_data"><span class="flagship-collapsable-header">Rückseite überspringen</span><button class="fflagship-collapsable-header-button2" type="button" data-trigger-id="engraving-change">bearbeiten</button></div>'
  );
});

// name back side edit btn
$(document).on(
  "click",
  ".halskette_backname_texts .engraving-editbutton",
  function () {
    var datatriggerId = $(this).attr("data-trigger-id");
    window.location.hash = "#popup";
    $(".Ruckseitengravur-model-main").addClass("model-open");
    $("body").addClass("popup_active");
    $(".Ruckseitengravur-model-main .popup_fonts")
      .find(datatriggerId)
      .addClass("name_active");
    $(".Ruckseitengravur-model-main .popup_fonts")
      .find(datatriggerId)
      .trigger("click");
  }
);

// name back side remove btn
$(document).on(
  "click",
  ".halskette_backname_texts .engraving-remove",
  function () {
    $(".halskette_rucks_texts").hide();
    $(".halskette_backname_texts .halskette_name_btn").show();
    $(".halskette_backname_texts .halskette_header").show();
    $(".halskette_backname_texts .halskette_input.backnamecancel_btn").show();
    $(this)
      .parents(".halskette_backname_texts ")
      .find(".halskette_rucks_texts")
      .html("");
    $(".Ruckseitengravur-model-main").find("#popup_name_images").html("");
    $(".Ruckseitengravur-model-main").find(".popup_name_inputs").val("");
    getPrice();
  }
);

$(document).on(
  "click",
  ".halskette_backname_texts .engraving-addedbutton",
  function () {
    var datatriggerId = $(this).attr("data-trigger-id");
    window.location.hash = "#popup";
    $(".Ruckseitengravur-model-main").addClass("model-open");
    $("body").addClass("popup_active");
    $(".Ruckseitengravur-model-main .popup_fonts")
      .find(datatriggerId)
      .addClass("name_active");
    $(".Ruckseitengravur-model-main .popup_fonts")
      .find(datatriggerId)
      .trigger("click");
  }
);

$(document).on(
  "click",
  ".halskette-product-add-btn.add-to-cart.disabled",
  function (event) {
    event.preventDefault();
    $(".error").show();
    $(".select-trigger").addClass("error-text");
  }
);

$(document).on(
  "click",
  ".halskette_backname_texts .flagship-collapsable-header-button",
  function () {
    window.location.hash = "#popup";
    $(".Ruckseitengravur-model-main").addClass("model-open");
    $("body").addClass("popup_active");
    $(".Ruckseitengravur-model-main .popup_fonts")
      .find(".frontname_1")
      .addClass("name_active");
    $(".Ruckseitengravur-model-main .popup_fonts")
      .find(".frontname_1")
      .trigger("click");
  }
);

$(document).on("change", ".halskette_radio input", function () {
  changeAddHalsketteProduct();
  getPrice();
});

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

function changeAddHalsketteProduct() {
  var list_item_value = $(".selected-option span.list_item_value").text();
  var checkedValue = $(".halskette_radio input:checked").attr("id");
  var mainProductvarId = $(".addHalsketteProduct")
    .parents(".product-single__form")
    .find(".product-single__variants")
    .val();
  console.log(mainProductvarId);
  if (
    !(list_item_value == "1 Tier/Person" || list_item_value == "") ||
    checkedValue == "Ja"
  ) {
    var title = list_item_value + " / " + checkedValue;
    var id = $('.addHalsketteProduct option[data-title="' + title + '"]').attr(
      "value"
    );
    $(".addHalsketteProduct").val(id);
  }
}

function addHalsketteProduct() {
  var list_item_value = $(".selected-option span.list_item_value").attr(
    "data-number"
  );
  //var mainProductvarId = $('.addHalsketteProduct').parents('.product-single__form').find('.product-single__variants').val();
  var mainProductvarId = getRandomInt(10000, 99999);
  var items = [];
  var bundleItem = [];

  if (list_item_value != "1") {
    var id = $(
      '.addHalsketteProduct option[data-title="' + list_item_value + '"]'
    ).attr("value");
    items.push({
      id: id,
      quantity: 1,
      properties: { _bundleWithItem: mainProductvarId },
    });
    bundleItem.push(id);
  }
  var checkedValue = $(".halskette_radio input:checked").attr("id");

  if (checkedValue == "Ja") {
    var id = $(".handzeichnung").val();
    items.push({
      id: id,
      quantity: 1,
      properties: { _bundleWithItem: mainProductvarId },
    });
    bundleItem.push(id);
  }
  var inputsproperty_1 = $(
    ".halskette_backname_texts .engraving-messagevalue"
  ).text();
  if (!(inputsproperty_1 === undefined || inputsproperty_1 == "")) {
    var id = $(".ruckseitengravur").val();
    items.push({
      id: id,
      quantity: 1,
      properties: { _bundleWithItem: mainProductvarId },
    });
    bundleItem.push(id);
  }
  $(".bundleItem").val(mainProductvarId);
  var data = {
    items: items,
  };
  console.log(data);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: data,
    success: function () {
      console.log("added");
    },
  });
}

function getPrice() {
  var id = $("[data-product-select]").val();
  var price =
    $(`[data-product-select] option[value="${id}"]`).attr("data-price") * 1;
  console.log(price);
  var personen = $(".halskette_personen").val();
  if (!(personen == "1" || personen == "" || personen == undefined)) {
    var halskette_personen_price =
      $('.addHalsketteProduct option[data-title="' + personen + '"]').attr(
        "data-price"
      ) * 1;
    price = price + halskette_personen_price * 1;
    console.log(price);
  }
  var checkedValue = $(".halskette_radio input:checked").attr("id");

  if (checkedValue == "Ja") {
    var handzeichnung_price = $(".handzeichnung").attr("data-price") * 1;
    price = price + handzeichnung_price;
    console.log(price);
  }
  var inputsproperty_1 = $(".engraving-messagevalue").text();
  if (!(inputsproperty_1 === undefined || inputsproperty_1 == "")) {
    var id = $(".ruckseitengravur").val();
    var ruckseitengravur_price =
      $('.ruckseitengravur option[value="' + id + '"]').attr("data-price") * 1;
    price = price + ruckseitengravur_price;
    console.log(price);
  }
  var formattedAmount = theme.Currency.formatMoney(
    price,
    theme.settings.moneyFormat
  );
  $("[data-product-price]").text(formattedAmount);
}

function uploadkit() {
  if ($(".uploadkit-thumbnail").children().length == 0) {
    $(".custom_uploadkit .uploadkit-uploader .image_save").remove();
  }
  $(".uploadkit-thumbnail").each(function (index) {
    var image = $(this);
    var field = image.next(".uploadkit-field");
    var wrapper = image.closest(".uploadkit-main-wrapper");
    //console.log($(this).find('.uploadkit-main-wrapper').length);
    if (wrapper.length === 0) {
      wrapper = $('<div class="uploadkit-main-wrapper"></div>');
      image.add(field).wrapAll(wrapper);
      $(this).wrap($('<div class="uploadkit-wrapper-img"></div>'));
      $(this).wrap($('<div class="wrapper-img"></div>'));
    }
    //console.log($('.uploadkit-thumbnail').children().length);

    // console.log($('.uploadkit-main-wrapper').length);
    if (
      $(".uploadkit-main-wrapper").length == 2 ||
      $(".uploadkit-main-wrapper").length == 1
    ) {
      $(".uploadkit-main-wrapper").css("width", "45%");
    }
    if (
      $(".uploadkit-main-wrapper").length == 3 ||
      $(".uploadkit-main-wrapper").length == 4 ||
      $(".uploadkit-main-wrapper").length == 5
    ) {
      $(".uploadkit-main-wrapper").css("width", "31%");
    }
    if ($(".custom_uploadkit .uploadkit-uploader .image_save").length == 0) {
      if ($(".uploadkit-main-wrapper").length >= 1) {
        $(".custom_uploadkit")
          .find(".uploadkit-button.uploadkit-button-uploaded")
          .before('<button type="button" class="image_save">Sichern</button>');
        $(".custom_uploadkit .uploadkit-uploader")
          .find(".uploadkit-button.uploadkit-button-uploaded")
          .addClass("uploaded_button_full");
      }
    }
  });
}
setInterval(uploadkit, 500);

$(document).on("click", ".uploadkit-wrapper-img", function (event) {
  if ($(event.target).is("div.wrapper-img")) {
    $(this).find("img.uploadkit-thumbnail").trigger("click");
  }
});
$(document).on("click", ".image_save", function (event) {
  $(".halsketteupload_header").hide();
  $(".halsketteupload_content").hide();
  $(".after_upload_photo").show();

  // setTimeout(function(){
  $("html, body").animate(
    {
      scrollTop: $("#variant_picker_id").offset().top - 40,
    },
    400
  );
  // },1000);
});

$(document).on("click", ".halsketteupload_edit_text", function (event) {
  $(".after_upload_photo").hide();
  $(".halsketteupload_header").show();
  $(".halsketteupload_content").show();
});

$(".Ruckseitengravur-model-main .frontnameinput_1").on("keyup", function () {
  var valDat = $(this).val();
  $(".Ruckseitengravur-model-main #popup_name_images").html(valDat);
  var inputValue = $(".Ruckseitengravur-model-main .frontnameinput_1").val();
  var convertedValue = inputValue;
  var elements = $(".frontname_4.name_active");
  if (elements.length > 0) {
    var words = inputValue.split(" ");
    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      var wordFirstCharacter = word.charAt(0);
      var wordRestOfText = word.substr(1).toLowerCase();
      words[i] = wordFirstCharacter + wordRestOfText;
    }
    var convertedValue = words.join(" ");
    $(this).val(convertedValue);
  }
  $(".Ruckseitengravur-model-main #popup_name_images").html(convertedValue);

  updateFontSize($(this));
});

function updateFontSize(item) {
  var text = item.val();
  var characters = text.length;
  var num = item.attr("data-number");
  console.log(num);
  console.log(characters);
  var popupName1 = $(".Ruckseitengravur-model-main .frontnameimg_1");
  var popupName2 = $(".Ruckseitengravur-model-main .frontnameimg_2");
  var popupName3 = $(".Ruckseitengravur-model-main .frontnameimg_3");
  var popupName4 = $(".Ruckseitengravur-model-main .frontnameimg_4");
  if (characters <= 2) {
    popupName1.css({
      "font-size": "60px",
      "line-height": "60px",
      top: "4px",
    });
    popupName2.css({
      "font-size": "65px",
      "line-height": "65px",
      top: "4px",
    });
    popupName3.css({
      "font-size": "60px",
      "line-height": "60px",
      top: "0px",
    });
    popupName4.css({
      "font-size": "60px",
      "line-height": "60px",
      top: "0px",
    });
  } else if (characters == 3) {
    popupName1.css({
      "font-size": "47px",
      "line-height": "47px",
      top: "4px",
    });
    popupName2.css({
      "font-size": "55px",
      "line-height": "55px",
      top: "4px",
    });
    popupName3.css({
      "font-size": "47px",
      "line-height": "47px",
      top: "0px",
    });
    popupName4.css({
      "font-size": "60px",
      "line-height": "60px",
      top: "0px",
    });
  } else if (characters == 4) {
    popupName1.css({
      "font-size": "36px",
      "line-height": "36px",
      top: "4px",
    });
    popupName2.css({
      "font-size": "40px",
      "line-height": "40px",
      top: "4px",
    });
    popupName3.css({
      "font-size": "36px",
      "line-height": "36px",
      top: "0px",
    });
    popupName4.css({
      "font-size": "50px",
      "line-height": "50px",
      top: "0px",
    });
  } else if (characters == 5) {
    popupName1.css({
      "font-size": "30px",
      "line-height": "30px",
      top: "4px",
    });
    popupName2.css({
      "font-size": "36px",
      "line-height": "36px",
      top: "4px",
    });
    popupName3.css({
      "font-size": "32px",
      "line-height": "32px",
      top: "1px",
    });
    popupName4.css({
      "font-size": "42px",
      "line-height": "42px",
      top: "0px",
    });
  } else if (characters == 6) {
    popupName1.css({
      "font-size": "28px",
      "line-height": "28px",
      top: "4px",
    });
    popupName2.css({
      "font-size": "32px",
      "line-height": "32px",
      top: "4px",
    });
    popupName3.css({
      "font-size": "24px",
      "line-height": "24px",
      top: "1px",
    });
    popupName4.css({
      "font-size": "40px",
      "line-height": "40px",
      top: "0px",
    });
  } else if (characters == 7) {
    popupName1.css({
      "font-size": "26px",
      "line-height": "26px",
      top: "4px",
    });
    popupName2.css({
      "font-size": "28px",
      "line-height": "28px",
      top: "4px",
    });
    popupName3.css({
      "font-size": "26px",
      "line-height": "26px",
      top: "2px",
    });
    popupName4.css({
      "font-size": "34px",
      "line-height": "34px",
      top: "0px",
    });
  } else if (characters == 8) {
    popupName1.css({
      "font-size": "24px",
      "line-height": "24px",
      top: "4px",
    });
    popupName2.css({
      "font-size": "27px",
      "line-height": "27px",
      top: "4px",
    });
    popupName3.css({
      "font-size": "24px",
      "line-height": "24px",
      top: "2px",
    });
    popupName4.css({
      "font-size": "38px",
      "line-height": "38px",
      top: "0px",
    });
  } else if (characters == 9) {
    popupName1.css({
      "font-size": "18px",
      "line-height": "18px",
      top: "4px",
    });
    popupName2.css({
      "font-size": "20px",
      "line-height": "20px",
      top: "4px",
    });
    popupName3.css({
      "font-size": "18px",
      "line-height": "18px",
      top: "2px",
    });
    popupName4.css({
      "font-size": "30px",
      "line-height": "30px",
      top: "0px",
    });
  } else if (characters > 9) {
    popupName1.css({
      "font-size": "16px",
      "line-height": "20px",
      top: "4px",
    });
    popupName2.css({
      "font-size": "18px",
      "line-height": "20px",
      top: "4px",
    });
    popupName3.css({
      "font-size": "16px",
      "line-height": "20px",
      top: "2px",
    });
    popupName4.css({
      "font-size": "25px",
      "line-height": "25px",
      top: "0px",
    });
  }
}
// Scroll on touch code
// Scroll on touch code for all elements matching the selector
function touchScroll($bind = "") {
  const sliders = document.querySelectorAll($bind);

  if (!sliders.length) {
    console.error(`No elements found with selector '${$bind}'.`);
    return;
  }

  sliders.forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;
    let velX = 0;
    let momentumID;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      cancelMomentumTracking();
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
      beginMomentumTracking();
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1; // Scroll fast
      var prevScrollLeft = slider.scrollLeft;
      slider.scrollLeft = scrollLeft - walk;
      velX = slider.scrollLeft - prevScrollLeft;
    });

    slider.addEventListener("wheel", (e) => {
      cancelMomentumTracking();
    });

    function beginMomentumTracking() {
      cancelMomentumTracking();
      momentumID = requestAnimationFrame(momentumLoop);
    }

    function cancelMomentumTracking() {
      cancelAnimationFrame(momentumID);
    }

    function momentumLoop() {
      slider.scrollLeft += velX;
      velX *= 0.95;
      if (Math.abs(velX) > 0.5) {
        momentumID = requestAnimationFrame(momentumLoop);
      }
    }
  });
}

// Usage example
touchScroll(".popup_fonts");

var interval = setInterval(checkURL, 1000);
function checkURL() {
  var currentURL = window.location.href;
  if (currentURL.indexOf("#") === -1) {
    $(".aufFoto-model-main").removeClass("model-open");
    $(".Weitere-model-main").removeClass("model-open");
    $(".Zeichnungsstil-model-main").removeClass("model-open");
    $(".Handzeichnung-model-main").removeClass("model-open");
    $(".Namen-model-main").removeClass("model-open");
    $(".Ruckseitengravur-model-main").removeClass("model-open");
    $("body.template-product").removeClass("popup_active");
  }
}
